import { useEffect, useState } from 'react';

import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';

import List from 'components/_parts/molecules/list/listBp';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

const InputMod1 = styled.div`
  flex: 0 0 70%;
  min-width: 0px;
`;

function Index({ t }: { t: (key: string) => string }) {
  const formik = useFormikContext();
  const { values }: any = formik;

  const [showTime, setShowTime] = useState(0);
  const [showTimeYear, setShowTimeYear] = useState(0);
  const isDisable = values.input_activity === '' || values.input_activity === undefined || values.input_standart_time === '' || values.input_standart_time === undefined;

  // workload
  useEffect(() => {
    let newShowTimeYear: any = 0;
    const newShowTime = values?.dataWorkload?.reduce(
      (accumulator: any, value: any) => accumulator + parseInt(value.standart_waktu),
      0,
    );
    newShowTimeYear = Math.round((newShowTime * 100) / 100).toFixed(2);

    setShowTime(newShowTime);
    setShowTimeYear(newShowTimeYear);
  }, [values?.dataWorkload]);

  const handleAdd = () => {
    const newItem = {
      activity_name: values.input_activity,
      standart_waktu: values.input_standart_time,
    };

    if (values.dataWorkload?.length === 0) {
      void formik.setFieldValue('dataWorkload', [newItem]);
    } else {
      void formik.setFieldValue('dataWorkload', [
        ...values.dataWorkload, newItem,
      ]);
    }

    let newTime = 0;
    let newTimeYear: any = 0;
    newTime = showTime + parseInt(values.input_standart_time);
    newTimeYear = Math.round((newTime * 100) / 100).toFixed(2);
    setShowTime(newTime);
    setShowTimeYear(newTimeYear);
    void formik.setFieldValue('input_activity', '');
    void formik.setFieldValue('input_standart_time', '');
  };

  const handleDelete = (val: any, index: number) => {
    if (values.dataWorkload?.length === 1) {
      formik.setValues({
        ...values,
        dataWorkload: [],
      });
    } else {
      const newData = values.dataWorkload.filter(
        (val: any, i: number) => i !== index,
      );
      formik.setFieldValue('dataWorkload', newData);
    }

    let newTime = 0;
    let newTimeYear: any = 0;
    newTime = showTime - parseInt(val.standart_waktu);
    newTimeYear = Math.round((newTime * 100) / 100).toFixed(2);
    setShowTime(newTime);
    setShowTimeYear(newTimeYear);
  };

  return (
    <div className="layout_workload_standard mt-3">
      <div className="title_workload_standard">
        <Label
          style={{
            fontSize: '24px',
            fontWeight: '800',
            color: '#4F4F4F',
            textAlign: 'center',
            fontFamily: 'Poppins',
            display: 'block',
          }}
        >
          {values?.dataWorkload?.length || 0}
          <span
            style={{
              display: 'block',
              marginTop: '0px',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {t('biz_process.total_activity')}
          </span>
        </Label>
        <Label
          style={{
            fontSize: '24px',
            fontWeight: '800',
            color: '#4F4F4F',
            textAlign: 'center',
            fontFamily: 'Poppins',
            display: 'block',
          }}
        >
          {showTime}
          <span
            style={{
              display: 'block',
              marginTop: '0px',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {t('biz_process.time_standart')}
          </span>
        </Label>
        <Label
          style={{
            fontSize: '24px',
            fontWeight: '800',
            color: '#4F4F4F',
            textAlign: 'center',
            fontFamily: 'Poppins',
            display: 'block',
          }}
        >
          {showTimeYear}
          <span
            style={{
              display: 'block',
              marginTop: '0px',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {t('biz_process.time_year')}
          </span>
        </Label>
      </div>
      <div className="input_form_workload_standard">
        <div className="input_form_workload_standard-Activity mb-3">
          <InputMod1>
            <Input
              id="float_activity"
              type="text"
              name="input_activity"
              value={values.input_activity}
              placeholder={t('biz_process.activity')}
              placeholderPosition="start"
              onChange={formik.handleChange}
            />
          </InputMod1>
          <Input
            id="float_standartTime"
            type="number"
            name="input_standart_time"
            value={values.input_standart_time}
            placeholder={t('biz_process.standart_time')}
            placeholderPosition="start"
            onChange={formik.handleChange}
          />
        </div>
        <Button
          icon="create"
          style={{ width: '140px', height: '40px', margin: '10px 0px 0 auto' }}
          disabled={isDisable}
          func={handleAdd}
        >
          {t('biz_process.add_activity')}
        </Button>
        <div className="mt-2 tw-px-1" style={{ maxHeight: '430px', overflow: 'auto' }}>
          <List
            data={values?.dataWorkload?.length === 0 ? [] : values?.dataWorkload}
            style={{ width: '60%' }}
            type="deleteWorkload"
            handleDelete={handleDelete}
          />
        </div>

      </div>
    </div>
  );
}

export default Index;
